import { ArdoqId } from '@ardoq/api-types';
import { actionCreator } from '@ardoq/rxbeach';

export const componentSelectedInQuickExploreMode = actionCreator<ArdoqId>(
  '[Quick explore] COMPONENT_SELECTED_IN_QUICK_EXPLORE_MODE'
);
